import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import CustomModal from './CustomModal';

const User_TopNav = ({ toggleSidebar, isOpen }) => {
  const navigation = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    const userToken = localStorage.getItem('token');
    const adminToken = localStorage.getItem('admin_token');

    localStorage.clear();

    if (userToken) {
      navigation('/auth/signin');
    } else if (adminToken) {
      navigation('/auth/admin_login');
    }
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <header className="topbar w-full lg:pl-[280px]">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="d-flex align-items-center">
              <div className="topbar-item">
                <button
                  type="button"
                  className="button-toggle-menu me-2 lg:hidden block"
                  onClick={() => toggleSidebar(!isOpen)}
                >
                  <iconify-icon
                    icon="solar:hamburger-menu-broken"
                    className="fs-24 align-middle"
                  ></iconify-icon>
                </button>
              </div>

              <div class="topbar-item">
                <h4 class="fw-bold topbar-button pe-none text-uppercase mb-0">
                  Welcome!
                </h4>
              </div>
            </div>

            <div class="d-flex align-items-center gap-1">
              {/* <div class="dropdown topbar-item">
                <button
                  type="button"
                  class="topbar-button position-relative"
                  id="page-header-notifications-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div
                    className="notification-icon cursor-pointer"
                    onClick={() => setIsModalOpen(true)}
                  >
                    <iconify-icon
                      icon="solar:bell-outline"
                      className="fs-24 align-middle"
                    ></iconify-icon>
                  </div>
                  {isModalOpen && (
                    <CustomModal
                      isOpen={isModalOpen}
                      onClose={() => setIsModalOpen(false)}
                    />
                  )}
                  <span class="position-absolute topbar-badge fs-10 translate-middle badge bg-danger rounded-pill">
                    3 <span class="visually-hidden">unread messages</span>
                  </span>
                </button>
                <div
                  class="dropdown-menu py-0 dropdown-lg dropdown-menu-end"
                  aria-labelledby="page-header-notifications-dropdown"
                >
                  <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                    <div class="row align-items-center">
                      <div class="col">
                        <h6 class="m-0 fs-16 fw-semibold"> Notifications</h6>
                      </div>
                      <div class="col-auto">
                        <a
                          href="javascript: void(0);"
                          class="text-dark text-decoration-underline"
                        >
                          <small>Clear All</small>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div data-simplebar style={{ maxHeight: '280px' }}>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item py-3 border-bottom text-wrap"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <img
                            src="/assets/images/users/avatar-1.jpg"
                            class="img-fluid me-2 avatar-sm rounded-circle"
                            alt="avatar-1"
                          />
                        </div>
                        <div class="flex-grow-1">
                          <p class="mb-0">
                            <span class="fw-medium">Josephine Thompson </span>
                            commented on admin panel{' '}
                            <span>
                              " Wow 😍! this admin looks good and awesome
                              design"
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="dropdown-item py-3 border-bottom"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <div class="avatar-sm me-2">
                            <span class="avatar-title bg-soft-info text-info fs-20 rounded-circle">
                              D
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <p class="mb-0 fw-semibold">Donoghue Susan</p>
                          <p class="mb-0 text-wrap">
                            Hi, How are you? What about our next meeting
                          </p>
                        </div>
                      </div>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="dropdown-item py-3 border-bottom"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <img
                            src="/assets/images/users/avatar-3.jpg"
                            class="img-fluid me-2 avatar-sm rounded-circle"
                            alt="avatar-3"
                          />
                        </div>
                        <div class="flex-grow-1">
                          <p class="mb-0 fw-semibold">Jacob Gines</p>
                          <p class="mb-0 text-wrap">
                            Answered to your comment on the cash flow forecast's
                            graph 🔔.
                          </p>
                        </div>
                      </div>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="dropdown-item py-3 border-bottom"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <div class="avatar-sm me-2">
                            <span class="avatar-title bg-soft-warning text-warning fs-20 rounded-circle">
                              <iconify-icon icon="iconamoon:comment-dots-duotone"></iconify-icon>
                            </span>
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <p class="mb-0 fw-semibold text-wrap">
                            You have received <b>20</b> new messages in the
                            conversation
                          </p>
                        </div>
                      </div>
                    </a>

                    <a
                      href="javascript:void(0);"
                      class="dropdown-item py-3 border-bottom"
                    >
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <img
                            src="/assets/images/users/avatar-5.jpg"
                            class="img-fluid me-2 avatar-sm rounded-circle"
                            alt="avatar-5"
                          />
                        </div>
                        <div class="flex-grow-1">
                          <p class="mb-0 fw-semibold">Shawn Bunch</p>
                          <p class="mb-0 text-wrap">Commented on Admin</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="text-center py-3">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary btn-sm"
                    >
                      View All Notification{' '}
                      <i class="bx bx-right-arrow-alt ms-1"></i>
                    </a>
                  </div>
                </div>
              </div> */}

              <div className="dropdown topbar-item">
                <div className="position-relative">
                  <a
                    type="button"
                    className="topbar-button"
                    onClick={toggleDropdown}
                  >
                    <span className="d-flex align-items-center gap-2">
                      <img
                        className="rounded-circle cursor-pointer"
                        width="32"
                        src="/assets/img/avatar-profile-photo.png"
                        alt="avatar-3"
                      />
                    </span>
                  </a>

                  {showDropdown && (
                    <div
                      className="dropdown-menu dropdown-menu-end"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        display: 'block',
                        minWidth: '200px',
                        padding: '0.5rem 0',
                        backgroundColor: '#fff',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        borderRadius: '4px',
                        zIndex: 1000,
                      }}
                    >
                      <h6 className="dropdown-header">Welcome User!</h6>
                      <NavLink
                        to={'/user_dashboard/user_profile'}
                        className="dropdown-item"
                      >
                        <i className="bx bx-user-circle text-muted fs-18 align-middle me-1"></i>
                        <span className="align-middle">Profile</span>
                      </NavLink>
                      <NavLink
                        to={'/user_dashboard/support_chat'}
                        className="dropdown-item"
                      >
                        <i className="bx bx-message-dots text-muted fs-18 align-middle me-1"></i>
                        <span className="align-middle">Messages</span>
                      </NavLink>
                      <div className="dropdown-divider my-1"></div>
                      <a
                        className="dropdown-item text-danger"
                        onClick={handleLogout}
                      >
                        <i className="bx bx-log-out fs-18 align-middle me-1"></i>
                        <span className="align-middle">Logout</span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default User_TopNav;
